import {Button} from "../../../../index";
import React from "react";
import FinaliseConfirm from "./FinaliseConfirm";
import {useViewerStore} from "../../../../../store/store";
import {RoofMesh} from "../../../../../@types/types";

interface SingleModuleAlertProps {
    roofs : RoofMesh[]
}

const ModuleOverSetbackValidation = () => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);
    const detachedStructureBuildingIds = useViewerStore(state => state.detachedStructureBuildingIds);

    const cancelFinalize = () => {
        sceneViewer.viewerAlert({show: false})
    }


    return (
        <>
            <p>
                Some modules are placed over the setback lines.
                <br/>
                <br/>
                ⚠️Your account does have permission to place module over setback line.
                <br/>
                <br/>
                Please adjust the design before finalizing.
                <br/>
                <br/>
                {
                    detachedStructureBuildingIds.length === 0 ? <>ℹ️ No detached structures detected.</> : <></>
                }
            </p>
            <br/>
            <div className={"modal-bottom-action-button-container"}>

                <Button
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-cancel-button"
                    onClick={cancelFinalize}
                >
                    Close & Review
                </Button>

            </div>
        </>
    )
}

export default ModuleOverSetbackValidation;